import View from 'cdna/core/view';    
import markup from './entryView.html';

export default View.extend({
    el: markup,
    bindings: {
        'Title [data-bind=title]': 'text',
        'Description [data-bind=description]': 'text',
        'Path [data-bind=url]': 'attr href',
        'FileName [data-bind=file-name]': 'text',
        'sizeDescription [data-bind=file-size]': 'text'
    }
});


/** WEBPACK FOOTER **
 ** ./client/guide/entryView.js
 **/